import { Component, OnInit, ViewChild } from '@angular/core';
import { Employment } from '../../../../common/models/employment';
import { EmploymentService } from '../employment.service';
import { UtilitiesService } from '../../../../common/shared/services/utilities.service';
import { OccupationEnum, StatusEnum } from '../../../../common/helper/enums';
import { DialogService } from '../../../../common/shared/services/dialog.service';
import { EmploymentFormComponent } from '../employment-form/employment-form.component';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../../../environments/environment';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../../../../components/layout/confirm-dialog/confirm-dialog.component';
import { OccupationFormComponent } from '../occupation-form/occupation-form.component';
import { PersonalDataService } from '../../personalData/personal-data.service';
import { Contact } from '../../../../common/models/contact';

@Component({
  selector: 'app-employment-view',
  templateUrl: './employment-view.component.html',
  styleUrls: ['./employment-view.component.scss']
})
export class EmploymentViewComponent implements OnInit {

  employmentsDataSource: MatTableDataSource<Employment>;
  public contact: Contact;

  displayedColumnsMemberships: string[] = [
    'title', 'employer', 'startUnixTimestamp', 'endUnixTimestamp', 'Actions'];

  StatusEnum: typeof StatusEnum = StatusEnum;
  OccupationEnum: typeof OccupationEnum = OccupationEnum;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private _matDialog: MatDialog,
    private _personalDataService: PersonalDataService,
    private _employmentService: EmploymentService,
    private _utilitiesService: UtilitiesService,
    private _dialogService: DialogService,
    private _translateService: TranslateService) { }

  ngOnInit() {
    this.employmentsDataSource = new MatTableDataSource<Employment>();
    this.employmentsDataSource.paginator = this.paginator;

    this._utilitiesService.addMinorAction('LoadEmployments');
    this.loadEmployments();

    this.contact = new Contact;
    this.loadContact();
  }

  private loadEmployments() {
    this._employmentService.loadEmployments().subscribe(
      data => {
        this.employmentsDataSource.data = this._utilitiesService.getData(data);

        this._utilitiesService.removeAction('LoadEmployments');
      },
      err => {
        this._utilitiesService.handleErrors(err);
      }
    );
  }

  deleteEmployment(employmendId: string) {
    this._utilitiesService.addMinorAction('DeleteEmployment');
    this._utilitiesService.addMinorAction('DeleteEmployment-' + employmendId);
    this._employmentService.deleteEmployment(employmendId).subscribe(
      data => {
        if (this._utilitiesService.getData(data)) {
          this._translateService.get(['portal.Profile.Employment.Delete.Success']).subscribe((res: string) => {
            this._dialogService.showSuccessDialog(res['portal.Profile.Employment.Delete.Success']);
          });
          this.loadEmployments();
        }
        this._utilitiesService.removeAction('DeleteEmployment');
        this._utilitiesService.removeAction('DeleteEmployment-' + employmendId);
      },
      err => {
        this._utilitiesService.handleErrors(err);
      }
    );
  }

  editAddEmployment(employmentId: string = '') {
    let transferEmployment = null;

    if (employmentId !== '') {
      transferEmployment = this.employmentsDataSource.data.find(obj => obj.id === employmentId);
    }

    const dialogRef = this._matDialog.open(EmploymentFormComponent, {
      width: environment.MatDilalogWidth,
      data: transferEmployment
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'SuccessCreate' || result === 'SuccessEdit') {
        this.loadEmployments();
        if (result === 'SuccessCreate') {
          this._translateService.get(['portal.Profile.Employment.Create.Success']).subscribe((res: string) => {
            this._dialogService.showSuccessDialog(res['portal.Profile.Employment.Create.Success']);
          });
        } else {
          this._translateService.get(['portal.Profile.Employment.Edit.Success']).subscribe((res: string) => {
            this._dialogService.showSuccessDialog(res['portal.Profile.Employment.Edit.Success']);
          });
        }
      } else if (result === 'ErrorCreate' || result === 'ErrorEdit') {
        this.loadEmployments();
        if (result === 'ErrorCreate') {
          this._translateService.get(['portal.Profile.Employment.Create.Error']).subscribe((res: string) => {
            this._dialogService.showErrorDialog(res['portal.Profile.Employment.Create.Error']);
          });
        } else {
          this._translateService.get(['portal.Profile.Employment.Edit.Error']).subscribe((res: string) => {
            this._dialogService.showErrorDialog(res['portal.Profile.Employment.Edit.Error']);
          });
        }
      }
    });
  }

  loadEmploymentsActive() {
    return this._utilitiesService.isActionActive('LoadEmployments');
  }

  deleteSomeEmploymentActive() {
    return this._utilitiesService.isActionActive('DeleteEmployment');
  }

  deleteEmploymentActive(employmentId: string) {
    return this._utilitiesService.isActionActive('DeleteEmployment-' + employmentId);
  }

  showTable() {
    return (this.employmentsDataSource &&
            this.employmentsDataSource.data &&
            this.employmentsDataSource.data.length > 0 &&
            !this._utilitiesService.isActionActive('LoadEmployments'));
  }

  confirmDialog(employmendId: string) {
    this._translateService.get(['portal.Profile.Employment.Confirm.Title', 'portal.Profile.Employment.Confirm.Text'])
    .subscribe((res: string) => {
      const confirmDialog = this._matDialog.open(ConfirmDialogComponent, {
        width: '400px',
        data: {
          title: res['portal.Profile.Employment.Confirm.Title'],
          message: res['portal.Profile.Employment.Confirm.Text']
        }
      });
      confirmDialog.afterClosed().subscribe(result => {
        if (result === true) {
          this.deleteEmployment(employmendId);
        }
      });
    });
  }

  loadContact() {
    this._personalDataService.loadContact().subscribe(
      data => {
        this.contact = this._utilitiesService.getData(data);
      },
      err => {
        this._utilitiesService.handleErrors(err);
      }
    );
  }

  changeOccupation() {
    const dialogRef = this._matDialog.open(OccupationFormComponent, {
      width: environment.MatDilalogWidth,
      data: {contact: this.contact}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'Success') {
        this.loadContact();
        this._translateService.get(['portal.Profile.Occupation.Update.Success']).subscribe((res: string) => {
          this._dialogService.showSuccessDialog(res['portal.Profile.Occupation.Update.Success']);
        });
      } else if (result === 'Error') {
        this._translateService.get(['portal.Profile.PersonalData.Update.Error']).subscribe((res: string) => {
          this._dialogService.showErrorDialogWithBody(res['portal.Profile.PersonalData.Update.Error']);
        });
      }
    });
  }
}

